import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getPublicIP} from '../../../utils/url';
import {EvaluationV2Template} from '../../templates/evaluation-v2.template';
import {
  createFirstTimeApplicationService,
  createUserAddress,
  executeUserCreditCheckService,
  fetchApplicationCreditCheckStatusService,
  setUserPersonalInfoService
} from '../../../services/new-services/application-v2.services';
import {useAnalytics} from "../../../hooks/useAnalytics.js";


export const EvaluationScreen = () => {
  const [currentResult, setCurrentResult] = useState('PENDING');
  const analytics = useAnalytics();
  const referralCode = useSelector((state) => state.applicationProcess.referralCode);
  const generalInfo = useSelector((state) => state.applicationProcess.generalInformation);
  const authToken = useSelector((state) => state.applicationProcess.authToken);
  const addressInfo = useSelector((state) => state.applicationProcess.address);
  const personalInfo = useSelector((state) => state.applicationProcess.personalInformation);
  const marketingMetadata = useSelector((state) => state.applicationProcess.marketingMetadata);
  const [applicationId, setApplicationId] = useState(null);
  const [processing, setProcessing] = useState(false);

  async function handleSubmit() {
    const addressResponse = await createUserAddress(authToken, addressInfo);
    if (!addressResponse.success) {
      console.log('Error creating address');
      return;
    }
    const personalResponse = await setUserPersonalInfoService(authToken, personalInfo);
    if (!personalResponse.success) {
      console.log('Error setting personal info');
      return;
    }
    const applicationPayload = {
      occupationId: generalInfo.userOccupation?.id,
      loanUsageId: generalInfo.loanUsage?.id,
      loanReferrerId: referralCode?.toUpperCase(),
      marketingData: marketingMetadata,
      deviceInfo: {
        location: null,
        ip: await getPublicIP(),
        contacts: null,
      },
      foundByAnswer: 'web',
    }
    const applicationResponse = await createFirstTimeApplicationService(authToken, applicationPayload);
    if (!applicationResponse.success) {
      console.log('Error creating application');
      return;
    }
    setApplicationId(applicationResponse.application.id);
    analytics.sendEvent({
      event: "Contact",
      event_category: "FormSubmission",
    });
    analytics.sendEvent({
      event: "CompleteRegistration",
      event_category: "FormSubmission",
    });
    window.gtag("event", "conversion", {
      send_to: "AW-11111897320/0eNnCKS9vZcYEOixyLIp",
    });
    setProcessing(true);
  }

  const evaluate_underwriting_p1 = async () => {
    await handleSubmit();
    const deviceInfo = {
      contacts: { total: -1, unique: -1 },
      location: { latitude: -1, longitude: -1 },
    };
    await executeUserCreditCheckService(
      authToken,
      deviceInfo,
      await getPublicIP(),
    );
  };

  async function handleCreditCheckUpdate(interval, timeout) {
    const { success, data } = await fetchApplicationCreditCheckStatusService(
      authToken,
      applicationId,
    );
    if (success && data?.result !== 'PENDING') {
      setCurrentResult(data?.result);
      clearInterval(interval);
      clearTimeout(timeout);
    } else if (!success) {
      clearInterval(interval);
      clearTimeout(timeout);
    }
  }

  useEffect(() => {
    evaluate_underwriting_p1();      
  },[]);

  useEffect(() => {
    if (!processing) return;
    let timeout;
    const interval = setInterval(() => {
      handleCreditCheckUpdate(interval, timeout);
    }, 5 * 1000);

    timeout = setTimeout(
      () => {
        if (interval) {
          clearInterval(interval);
        }
        setCurrentResult('IN_REVIEW');
        clearTimeout(timeout);
      },
      3 * 60 * 1000,
    );

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [processing]);

  return (
    <div style={styles.mainContainerStyle}>
      {/* <CreditCheckEvaluationTemplate loanAmount={75000} currentResult={currentResult} /> */}
      <EvaluationV2Template />
    </div>
  );
};

const styles = {
  mainContainerStyle: {
    margin: '0 auto',
    padding: window.innerWidth > 700 ? '0 25%' : '0'
  }
}